<div class="f-row custom-dialog">
    <div class="container d-justify-bw">
      <div class="verify-title">
        <div class="title">
          <h3 class="title-text">{{content?.['b2b.managetraveler.addotherpref']}}</h3>
          <span class="sub-title">{{content?.['b2b.managetraveler.selectotherpref']}} </span>
        </div>
        <div class="close">
          <button aria-label="close button" mat-icon-button>
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
      </div>
  
      <div class="f-col d-align-center verify-body">
        <mat-chip-set class="chip-rows">
          <mat-chip>Wheelchair lithium ion battery</mat-chip>
          <mat-chip>Wheelchair (cannot climb stairs)</mat-chip>
          <mat-chip class="selected"
            >Deaf passenger<button aria-label="chip remove button" matChipRemove>
              <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
            </button></mat-chip>
          <mat-chip>Wheelchair (can climb stairs)</mat-chip>
          <mat-chip>Wheelchair (PAX completely immobile)</mat-chip>
        </mat-chip-set>
      </div>
  
      <div class="f-col d-align-right verify-footer">
        <button mat-button class="button--primary-small">{{content?.['b2b.managetraveler.add']}}</button>
      </div>
    </div>
  </div>
  